import React from 'react';
import type { StimulusIconKey } from '@interactive-room';

interface StimulusThemeIconProps {
  icon: StimulusIconKey;
}

function SportIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden className="print-stimulus__icon-svg">
      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="1.5" />
      <path d="M12 3c2 3 2 15 0 18M12 3c-2 3-2 15 0 18M3 12h18" stroke="currentColor" strokeWidth="1.2" fill="none" />
    </svg>
  );
}

function ScienceIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden className="print-stimulus__icon-svg">
      <path
        d="M9 3h6l1 7-4 11-4-11 1-7z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path d="M8 10h8" stroke="currentColor" strokeWidth="1.2" />
    </svg>
  );
}

function HistoryIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden className="print-stimulus__icon-svg">
      <path d="M5 20V8l7-4 7 4v12H5z" fill="none" stroke="currentColor" strokeWidth="1.5" />
      <path d="M9 20v-6h6v6M12 8v3" stroke="currentColor" strokeWidth="1.3" />
    </svg>
  );
}

function NatureIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden className="print-stimulus__icon-svg">
      <path
        d="M12 21c-4-3-7-7-7-11a7 7 0 0 1 14 0c0 4-3 8-7 11z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path d="M12 21V10M9 13c1-2 3-3 3-3s2 1 3 3" stroke="currentColor" strokeWidth="1.2" fill="none" />
    </svg>
  );
}

function GeneralIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden className="print-stimulus__icon-svg">
      <path d="M4 6h16M4 12h10M4 18h14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

const ICONS: Record<StimulusIconKey, React.FC> = {
  sport: SportIcon,
  science: ScienceIcon,
  history: HistoryIcon,
  nature: NatureIcon,
  general: GeneralIcon,
};

export function StimulusThemeIcon({ icon }: StimulusThemeIconProps) {
  const Icon = ICONS[icon] ?? GeneralIcon;
  return (
    <div className="print-stimulus__icon" aria-hidden>
      <Icon />
    </div>
  );
}
